import React from 'react'
import { Link, withRouter } from 'react-router-dom'
import { pure } from 'recompose'
import Icon from "modules/common/components/icon/Icon"
import { ICONS } from 'modules/common/components/icon/Icons'
import { Card, CardImage, CardContent, CardHeader, CardInfoWithIcon, CardPrice, DiscountBadge } from 'modules/common/components/ui/Card'
import { formatPrice } from 'utils/price-utils'
import withLocalized from 'modules/localization/withLocalized'

const currencyLocale = process.env.REACT_APP_NODE_ENV === 'ie' ? 'en-GB' : 'fi-FI';

const onClick = (event, history, linkProps) => {
  event.preventDefault()
  history.push(linkProps);
}

const ServiceCard = (props) => {
  const {
    localized,
    courseAddress,
    className = undefined,
    history,
    location: {
      pathname,
      search,
    },
    event: {
      id,
      title,
      image,
      place,
      participants_count,
      participants_max,
      prices = [],
      currency,
      discount_badge,
    } = {},
    fluid = false,
    onMouseOver = () => {},
    onMouseOut = () => {},
    activeOnHover = false,
    active = false,
    children,
  } = props;

  const canBeBooked = parseInt(participants_count, 10) < parseInt(participants_max, 10);

  const lowestPrice = Math.min(...prices.map(p => parseInt(p.price_value, 10)))
  
  const pricePrefix  = localized("service.price_prefix")

  const imageSrc = image instanceof Array && image.length > 0 ? image[0].formatted_large : undefined;
  
  const linkProps = {
    pathname: `/services/${id}`,
    state: { backLink: `${pathname}${search}` }
  };
  
  return (
    <Card clickable activeOnHover={activeOnHover} active={active} fluid={fluid} className={className} onMouseOver={e => onMouseOver(props.event)} onMouseOut={onMouseOut} onClick={event => onClick(event, history, linkProps)}>
      <Link className="card__anchor" to={linkProps}>
        <CardImage src={imageSrc} />
        { discount_badge && (
          <DiscountBadge>
            <Icon icon={ICONS.SAVENOWBG} height="72px" width="72px" />
            <span className="discount--text">
              <small>{ localized("service.save_now_label") }</small><br />
              {discount_badge}
            </span>
          </DiscountBadge>
        )}
        { (lowestPrice !== '' && !isNaN(lowestPrice) && canBeBooked) && <CardPrice>{`${pricePrefix} ${formatPrice(lowestPrice, currency, currencyLocale)}`}</CardPrice> }
      </Link>
      <CardContent>
        <CardHeader>
          <Link to={linkProps}>{title}</Link>
        </CardHeader>
        {place && (
          <CardInfoWithIcon icon={ICONS.PIN_FLAG}>
            <span dangerouslySetInnerHTML={{__html:  place || '-'}}/>
          </CardInfoWithIcon>)
        }
        { courseAddress && <CardInfoWithIcon icon={ICONS.LOCATION}>{courseAddress}</CardInfoWithIcon> }
      </CardContent>
      { children }
    </Card>
  )
};

export default pure(withLocalized(withRouter(ServiceCard)));



// WEBPACK FOOTER //
// ./src/modules/events/components/ServiceCard.js